export default __webpack_public_path__ + "static/media/몰루.62762966.gif";